import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useTimerSkillSelect } from './useTimerSkillSelect';

interface TimerSkillSelectProps {
  onOpenPicker: () => void;
  onClear: () => void;
}

/**
 * Its own component so the skill list is only fetched where the field is rendered. It renders the
 * trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const TimerSkillSelect = ({ onOpenPicker, onClear }: Readonly<TimerSkillSelectProps>) => {
  const { t } = useTranslation();
  const select = useTimerSkillSelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('transaction:requiredSkill')}
      placeholder={t('transaction:selectSkill')}
      searchPlaceholder={t('transaction:searchSkills')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      data-field="skill"
      data-testid="timer-skill-select-button"
    />
  );
};

export default TimerSkillSelect;
